module.exports = __webpack_public_path__ + "img/1.0a1a60d.png";